<template>
  <Container judul="Beranda">
    <template #header>
      <HeaderFe />
    </template>

    <template v-slot:default>
      <div class="min-h-screen pb-16 bg-gray-50/40">
        <main class="pt-28">
          <!-- Dynamic Widgets (Hero, Statistik, dll diaktifkan dari menu Widget) -->
          <template
            v-if="
              activeWidgets &&
              activeWidgets.data &&
              activeWidgets.data.length > 0
            "
          >
            <div v-for="widget in activeWidgets.data" :key="widget.id">
              <WidgetComponent :widget="widget" />
            </div>
          </template>

          <!-- Fallback sections when no dynamic widgets are active -->
          <template v-else>
            <AgendaSection :agenda="agenda" />
            <AuthorSection :formasi="formasi" />
            <BlogSection :news="news" />
            <GraphSection :grafik="grafik" />
            <DokumenList :jenisdokumen="jenisdokumen" />
          </template>
        </main>
      </div>
    </template>

    <template #footer>
      <FooterFe class="mt-auto" />
    </template>
  </Container>
</template>

<script setup>
import { defineProps, provide } from "vue";
import Container from "@/Layouts/Container.vue";
import HeaderFe from "@/Components/HeaderFe.vue";
import FooterFe from "@/Components/FooterFe.vue";

// Frontend building blocks
import AgendaSection from "@/Components/Web/AgendaSection.vue";
import AuthorSection from "@/Components/Web/AuthorSection.vue";
import BlogSection from "@/Components/Web/BlogSection.vue";
import GraphSection from "@/Components/Web/GraphSection.vue";
import DokumenList from "@/Components/Web/DokumenList.vue";

// Dynamic widget loader
import WidgetComponent from "@/Components/Web/WidgetLoader/WidgetComponent.vue";

const props = defineProps({
  formasi: {
    type: Object,
    required: true,
  },
  news: {
    type: Object,
    required: true,
  },
  slider: {
    type: Object,
    required: true,
  },
  agenda: {
    type: Object,
    required: true,
  },
  grafik: {
    type: Object,
    default: () => ({ data: [] }),
  },
  jenisdokumen: {
    type: Object,
    required: true,
  },
  activeWidgets: {
    type: Object,
    default: () => ({ data: [] }),
  },
  pemilihan: {
    type: Object,
    default: () => ({ data: [] }),
  },
  pengumuman: {
    type: Object,
    default: () => ({ data: [] }),
  },
});

// Provide all data so child components (e.g. WidgetComponent) can inject it.
provide("formasi", props.formasi);
provide("news", props.news);
provide("slider", props.slider);
provide("agenda", props.agenda);
provide("grafik", props.grafik);
provide("jenisdokumen", props.jenisdokumen);
provide("pemilihan", props.pemilihan);
provide("pengumuman", props.pengumuman);
</script>
